import React from 'react';
import styles from './style.less';
import { connect } from 'dva';
import { getMapStateToProps } from '@/utils/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { Tag } from 'antd';

const PackageInfoItem: React.FC<any> = (props: any) => {
  const {
    helper: { tx },
    info,
  } = props;

  return (
    <div>
      {info.map((data: any, idx: any) => (
        <div className={styles.cardInfoContainer} key={idx}>
          <div>
            <div className={styles.blackTitle}>{tx(data.title)}</div>
          </div>

          {data.description.map((item: any, idx: any) => (
            <div className={styles.descContainer} key={idx}>
              <div>
                <FontAwesomeIcon style={{ color: '#003566' }} icon={faCheck} />
              </div>

              <div key={idx}>
                <div className={styles.descInfo}>
                  {tx(item.desc)}
                  {item.showTag && <Tag style={{ marginLeft: 8 }}>{tx('Package.coming')}</Tag>}
                </div>
                {/* subDesc is a child of desc */}
                {item.subDesc &&
                  item.subDesc.map((item: any, idx: any) => (
                    <div className={styles.subDescContainer} key={idx}>
                      <div className={styles.subDescIcon}>
                        <FontAwesomeIcon icon={faThumbsUp} />
                      </div>
                      <div className={styles.subDescInfo}>
                        <div>{tx(item)}</div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default connect(getMapStateToProps(['meta']))(PackageInfoItem);
